import { Injectable } from '@angular/core';
// import { JwtHelperService } from '@auth0/angular-jwt';
export const TOKEN = 'access_token';
@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  // 2024/10/08 kyrie: 移除call API時 代入的JWT Header (access_token)
  // constructor(private jwtHelper: JwtHelperService) { }
  constructor() { }

  isTokenExpired(token: string = TOKEN): boolean {
    const jwtStr = this.getToken(token);
    if (jwtStr) {
      const object = JSON.parse(jwtStr),
        dateString = object.timestamp,
        now = new Date().getTime().toString();
      if (Number(now) < Number(dateString + (1000 * 60 * 60 * 24))) {
        return false;
      } else {
        return true; // otp timeout
      }
      // return this.jwtHelper.isTokenExpired(jwtStr);  // token expired?
    } else {
      return true;
    }
  }

  writeToken(object: any, token: string = TOKEN) {
    localStorage.setItem(token, JSON.stringify(object));
  }

  getToken(token: string = TOKEN) {
    return localStorage.getItem(token);
  }

  removeToken(token: string = TOKEN) {
    if (this.getToken(token)) {
      localStorage.removeItem(token);
    }
  }
}
